export const promotedCredsStringsFabric = {
  linkedinText: getLocalString("Login_UseLinkedIn_Link"),
  githubText: getLocalString("Login_UseGitHub_Link"),
  googleText: getLocalString("Login_UseGoogle_Link"),
  facebookText: getLocalString("Login_UseFacebook_Link"),
};
